import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/bars-graphs/pie-chart/pie-chart.js';
      import {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';

      export interface Props {
     data?: { label: string; value: number; children?: { label: string; value: number; }[] | undefined; }[];
     colors?: string[];
     priority?: Priority;
     showOuterLabels?: boolean;
     showUnit?: boolean;
     sunburst?: boolean;
     outerLabelUnit?: string;
     outerLabelMaxLength?: number;
     outerLabelDecimalPlaces?: number;
     legend?: boolean;
     showDebugOverlay?: boolean;
     fixedHeight?: number
   }

      
  
      export type {Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPieChart',
  props: {
    data: {},
    colors: {},
    priority: {},
    showOuterLabels: { type: Boolean },
    showUnit: { type: Boolean },
    sunburst: { type: Boolean },
    outerLabelUnit: {},
    outerLabelMaxLength: {},
    outerLabelDecimalPlaces: {},
    legend: { type: Boolean },
    showDebugOverlay: { type: Boolean },
    fixedHeight: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-pie-chart',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})